module.exports = "<div class=\"form-group form-search\">\n  <div class=\"input-group\" [class.show]=\"hasResults\">\n    <input class=\"form-control dropdown-toggle\" type=\"text\"\n           [(ngModel)]=\"nameSearch\"\n           placeholder=\"{{placeholderText | translate}}\"\n           (blur)=\"onBlur()\">\n    <div class=\"input-group-addon\"><i class=\"glyph-search\"></i></div>\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/inline-search/inline-search.component.html
// module id = 1Wrw
// module chunks = 0